module.exports = __webpack_public_path__ + "img/face-rolling-eyes.a7df9e13.svg";